export default __webpack_public_path__ + "static/sand2-3d4db122204e350713a9a3a9a1d7117a.webp";